import { h } from 'preact';
import { Route, Router } from 'preact-router';
import { createHashHistory } from 'history';
import { CustomerExperience } from '../features/customer-experience/customer-experience';
import { observer } from 'mobx-react';
import AsyncRoute from 'preact-async-route';
import Loading from '../components/loading/loading';

const NotFoundPage = () => import('../pages/not-found-page/not-found-page').then(module => module.default);

export const AppRouter = observer(() => {
	const hashHistory = createHashHistory();

	const renderSharedLocation = ({ shared_location_uuid }) => {
		return <CustomerExperience key={shared_location_uuid} shared_location_uuid={shared_location_uuid} />;
	};

	return (
		<Router history={hashHistory}>
			<Route path="/s/:shared_location_uuid/:env_query" component={renderSharedLocation} />
			<Route path="/s/questionnaire/:shared_location_uuid/:env_query" component={renderSharedLocation} />
			<AsyncRoute path="/" default getComponent={NotFoundPage} loading={() => <Loading />} />
		</Router>
	);
});
